import React, { forwardRef, Ref, SVGAttributes } from 'react';

const GoogleCalendar = forwardRef(
  (props: SVGAttributes<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
      ref={ref}
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M24.4886 7.5791H7.64648V24.4212H24.4886V7.5791Z" fill="white" />
      <path d="M24.4883 31.9998L32.0672 24.4209H24.4883V31.9998Z" fill="#EA4335" />
      <path d="M32.0672 7.5791H24.4883V24.4212H32.0672V7.5791Z" fill="#FBBC04" />
      <path d="M24.4886 24.4209H7.64648V31.9998H24.4886V24.4209Z" fill="#00ADEF" />
      <path
        d="M0.0664062 24.4209V29.4735C0.0664062 30.8693 1.19693 31.9998 2.59272 31.9998H7.64535V24.4209H0.0664062Z"
        fill="#00ADEF"
      />
      <path
        d="M32.0672 7.57895V2.52632C32.0672 1.13053 30.9367 0 29.5409 0H24.4883V7.57895H32.0672Z"
        fill="#1967D2"
      />
      <path
        d="M24.4875 0H2.59272C1.19693 0 0.0664062 1.13053 0.0664062 2.52632V24.4211H7.64535V7.57895H24.4875V0Z"
        fill="#4285F4"
      />
      <path
        d="M11.1 20.6439C10.4706 20.2186 10.0348 19.5976 9.79688 18.7765L11.2579 18.1744C11.3906 18.6797 11.6221 19.0713 11.9527 19.3491C12.2811 19.627 12.6811 19.7639 13.1485 19.7639C13.6264 19.7639 14.0369 19.6186 14.38 19.3281C14.7232 19.0376 14.8958 18.667 14.8958 18.2186C14.8958 17.7597 14.7148 17.3849 14.3527 17.0944C13.9906 16.8039 13.5358 16.6586 12.9927 16.6586H12.1485V15.2123H12.9063C13.3737 15.2123 13.7674 15.086 14.0874 14.8334C14.4074 14.5807 14.5674 14.2355 14.5674 13.7955C14.5674 13.4039 14.4242 13.0923 14.1379 12.8586C13.8516 12.6249 13.4895 12.507 13.0495 12.507C12.62 12.507 12.279 12.6207 12.0263 12.8502C11.7739 13.0803 11.5841 13.3708 11.4748 13.6944L10.0285 13.0923C10.22 12.5491 10.5716 12.0691 11.0874 11.6544C11.6032 11.2397 12.2621 11.0312 13.0621 11.0312C13.6537 11.0312 14.1863 11.1449 14.6579 11.3744C15.1295 11.6039 15.5 11.9218 15.7674 12.326C16.0348 12.7323 16.1674 13.187 16.1674 13.6923C16.1674 14.2081 16.0432 14.6439 15.7948 15.0018C15.5463 15.3597 15.2411 15.6334 14.879 15.8249V15.9113C15.3465 16.104 15.7527 16.4206 16.0537 16.827C16.359 17.2376 16.5127 17.7281 16.5127 18.3007C16.5127 18.8734 16.3674 19.3849 16.0769 19.8334C15.7863 20.2818 15.3842 20.6355 14.8748 20.8923C14.3632 21.1491 13.7885 21.2797 13.1506 21.2797C12.4116 21.2818 11.7295 21.0691 11.1 20.6439V20.6439ZM20.0748 13.3934L18.4706 14.5534L17.6685 13.3365L20.5463 11.2607H21.6495V21.0523H20.0748V13.3934Z"
        fill="#4285F4"
      />
    </svg>
  ),
);

export default GoogleCalendar;
